import { useHistory, useLocation, useParams } from "react-router-dom";
import { FC, useState, useCallback, useEffect, useMemo, useRef } from "react";
import { useTranslation } from "react-i18next";
import { NavBar, NavbarWidget } from "shared/components/__FOX__/NAV/src";
import {
  BLangSwitcher,
  Colors,
  FlexBox,
  NavbarButtonFilled,
  NavbarLogoName,
  useBreakpoint,
  useIsMobile,
} from "@brg/ui";
import { CreateLinkTo, LinkTo } from "shared/constants/linkTo";
import styled, { css, useTheme } from "styled-components";
import { BacklogModalView } from "shared/components/backlog";
import { setAppLang } from "../components/__ADDONS__/__LANG__/Slice";
import { SaveUserLang } from "../components/__ADDONS__/__LANG__/Utils/GetUserLang";
import { AppTester, getContextFromAppName } from "supporting";
import {
  LayoutConst,
  modalControllerSelector,
} from "core/modules";
import useSingleTagModal from "../hooks/useSingleTagModal";
import DeziignNavBarMobile from "./DeziignNavBarMobile";
import WidgetLogin from "./WidgetLogin";
import SectionDeziign from "./SectionDeziign";
import { RectangularButtonHollow } from "shared/components/buttons";
import { ApplicationShared, bURL } from "core";
import { useAuth } from "../../core/hooks/auth/useAuth";
import { useRouteMatch } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import OnlinesLogo from "shared/assets/logos/OnlinesLogo";
import { ApplyBtn } from "shared/components/Footer/OnlinesFooter";
import { useOnlinesParam } from "shared/hooks/OnlinesParamFilter";
import { BLanguageSelectionComponentOnlines } from "core/components/BLanguageSelectionComponentOnlines";
import useQueryState from "shared/hooks/useQueryState";
import { ModalMenuContextMobileNew } from "./ModalMenuContextMobileNew";
import { NeutralLink } from "../components/link/styles";
import { ProfileRole, bProfile, useProfile } from "@brg/auth";
import ViewTypeControllerWide from "../components/ViewTypeControllerWide/ViewTypeControllerWide";
import NotificationsController from "../components/NotificationsController/NotificationsController";
import { useNotificationContext } from "../contexts/NotificationContext";
import { MainSearchButton } from "shared/components/MainSearchController/MainSearchButton";
import TeamInfo from "../components/TeamInfo/TeamInfo";
import useExternalOrganization from "../pages/exploreHseContextsNew/useExternalOrganization";
import { ModerationType } from "../pages/teams/const/ModerationTypes";
import SectionSuperPuper from "./SectionSuperPuper";
import { HsePolicies } from "shared/constants/HsePolicies";
import FeedButton from "../components/NotificationsController/FeedButton";
import SectionCGrave from "./SectionCGrave";
import {useGetFilteredTabs} from "../components/navigationSystem/useGetFilteredTabs";
import { useGetLogo } from "shared/components/navigationSystem/useGetLogo";
import {getShouldDisplaySearch} from "../helpers/getShouldDisplaySearch";
import { API, CardAPI, Endpoints, Team } from "@brg/api";
import { useGetCatalogs } from "shared/hooks/api/useGetCatalogs";
import { ProjectEditPageGridInput } from "_deziiign/books/pages/BookEdit/styles";
import { Input } from "@brg/input";
import urlApi from "shared/actions/urlApi";
import ChannelButton from "shared/components/NotificationsController/ChannelButton";
import { NavbarSearchActions } from "shared/reducers/NavbarSearch";
import GameButton from "shared/components/NotificationsController/GameButton";
import { useChannelsContext } from "shared/contexts/ChannelsContext";
import { hasDefaultChannel, hasPersonalChannel } from "shared/helpers/teamsStatus";
import { useGetFeedInfo } from "shared/hooks/api/useGetFeedInfo";
import { ChapterPager } from "./components/ChapterPager";

interface CustomDropdownProps {
  lang: string;
}

export const LogoName = styled(NavbarLogoName)`
  top: -1px;
`;

export const DropdowCreateProjectnWrapper = styled(FlexBox)`
  white-space: nowrap;
`;

const CustomDropdown = styled(Input.Dropdown)`
  .brg-input__control {
    height: 20px !important;
    width: ${p => p.lang === 'en' ? '219px' : '250px'} !important;
    color: #FEFEFE !important;
    background-color: #151514 !important;
    border: 1px solid #444 !important;
    box-shadow: none !important;
    padding-left: 8px;
    cursor: pointer;
  }

  .brg-input__value-container{
    height: 100% !important;
    margin-top: -3px;
  }

  .brg-input__control:hover svg {
    fill:  #FEFEFE !important;
    color: #FEFEFE !important;
  }

  .brg-input__placeholder{
    color: #FEFEFE !important;
    font-weight: 600;
  },

  .brg-input__placeholder:hover{
    color: #FEFEFE !important;
  }
  .brg-input__control:hover .brg-input__placeholder {
    color: #FEFEFE !important;
  }

  .brg-input__menu {
    border-radius: 3px;
    margin-top: 8px;
  }

  .brg-input__menu-list {
    padding: 0;
  }

  .brg-input__option {
    color: #ddd !important;
    padding: 8px 12px;
    display: flex;
    word-wrap: break-word;
    overflow-wrap: break-word;
    white-space: normal;
  }

  .brg-input__indicator {
    width: auto;
    
  }

  .brg-input__dropdown-indicator svg path{
    fill: #fefefe !important;
  }

  .brg-input__dropdown-indicator{
    opacity: 1;
    margin-right: 14px;
    padding: 8px 8px 8px 10px;
  }

  .brg-input__control:hover svg { fill: #FEFEFE !important; }

`;

export const OpenDayButton = styled(FlexBox)`
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  /* margin-right: 48px; */
  background: #fa4800;
  border-radius: 16px;
  padding: 12px 32px;
  color: #fff;
  align-items: center;
  gap: 10px;

  white-space: nowrap;

  @media (max-width: ${LayoutConst.screen.m}px) {
    font-size: 12px;
    line-height: 16px;
    gap: 3px;
    padding: 6px 12px;
    margin-right: 12px;
    margin-left: -12px;
    border-radius: 12px;
  }
`;

const NavBarWrapper = styled.div<any>`
  ${p => p.isKiiidsArt && 
    css`
    & > div > div > div {
      @media (max-height: ${LayoutConst.screen.height.projectCover}px) {
          height: 52px;
          min-height: 52px;       
        }
    }       
      div#navbar {
        #navbar-sections {
          margin-left: 24px;
        }
        .links-widget-item {
          font-size: 15px;
        }
        margin: 0 40px;
        @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
          margin: 0 22px 0 32px;
        }
        @media (max-width: ${LayoutConst.screen.l}px) {
          margin: 0 16px;
        }
      }
    `
  }
`

const NavbarButtonWrapper = styled<any>(FlexBox)`
  button {
    ${p => !p.isKiiidsArt && 'max-width: max-content;'}
    ${p => p.isKiiidsArt && css`
        height: 40px !important;
      `}
  }
`

const LangSwitcherWrapper = styled.div<any>`
  div.langitem-active {
    ${p => p.isKiiidsArt && 'color: #FEFEFE;'}
  }
`
const cardUrl = Endpoints.cardsMnePw;

export const DeziignNavBar: FC = () => {
  const location = useLocation();
  const history = useHistory();
  const { emit } = useAuth();
  const {
    t,
    i18n,
    i18n: { language },
  } = useTranslation();
  const dispatch = useDispatch();
  const [showTagModal] = useSingleTagModal();
  const profile = useProfile();
  const { connection } = useNotificationContext();

  const theme = useTheme();
  const [visibleError, setVisibleError] = useState(false);
  const [visibleChoosePopUp, setVisibleChoosePopUp] = useState<boolean>(false);
  const [{ lang, tab: queryTab }, setQueryParams] = useQueryState();

  const isBrnd = AppTester.isBrnd();
  const isAgeytomesh = AppTester.isAgeytomesh();
  const isHseAnimation = AppTester.isHseAnimation();
  const isDeziiign = AppTester.isDeziiign();
  const isGeo = AppTester.isGeograffee();
  const isOnlines = AppTester.isOnlines();
  const isMedia = AppTester.isMediiia();
  const isLectureMediiia = AppTester.isLectureMediiia();
  const isHseSpace = AppTester.isHseSpace();
  const isLPU = AppTester.isLPUDesign();
  const isGreenAward = AppTester.isGreenAward();
  const isProDeziiign = AppTester.isProDeziiign();
  const isProHSE = AppTester.isProHSE();
  const isMonaLisaTravels = AppTester.isMonaLisaTravels();
  const isDODOnlines =
    location.pathname.startsWith("/dop") || AppTester.isOnlines();
  const isPreview = useRouteMatch<{ id: string }>([
    "/preview/:id",
    "/books/book-preview/:id",
    "/book-preview/:id",
  ]);
  const isTeamLgPreview = useRouteMatch<{ id: string }>('/team-longread-preview/:id');
  const isTeamAdmin = useRouteMatch('/teamAdmin')
  const isMain = !!useRouteMatch("/")?.isExact;
  const isForcedLanding = !!useRouteMatch('/brnd')
  const isTeam = !!useRouteMatch("/teams/:id");
  const isMainOrTeam = isMain || isTeam || isForcedLanding;
  const id = isPreview && isPreview?.params?.id || isTeamLgPreview && isTeamLgPreview?.params?.id;

  const teamId = useRouteMatch('/teams/:id');

  const { teamName } = useParams<{ teamName: string }>();
  const team = useExternalOrganization(teamName);

  // console.log('profile', profile)


  const isDropdownEnabled = isProDeziiign || isProHSE;

  const [navProTypeValue, setNavProTypeValue] = useState<{ label: string; value: string } | null>(null);

  useEffect(() => {
    const createPath = CreateLinkTo.projectCreate();
    if (!location.pathname.startsWith(createPath)) {
      setNavProTypeValue(null);
    }
  }, [location.pathname]);
  
  const navigateWithType = (typeValue: string) => {
    history.push(CreateLinkTo.projectCreate(), { selectedType: typeValue })
  };

  // @ts-ignore
  // const [isTeamOwner] = useGetIsOwner(team?.teamId ?? "");

  const isTeamOwner = useMemo(
    () => {
      const tTeam = team as Team;

      if (!profile || !team) return undefined;

      return tTeam?.ownersIDs?.includes(profile?.accountId)
    } 
  , [team, profile])
    

  // @ts-ignore
  const isLMS =
    AppTester.isLMSHSE() ||
    //@ts-ignore
    team?.moderationType == ModerationType.LMS;

  const isMobile = useIsMobile();
  const isTablet = useBreakpoint(1200);
  const is834bp = useBreakpoint(834);
  const isDesignBooks = AppTester.isBooksMain();
  const isGalllleryBooks = AppTester.isBooksGallllery();
  const isMainBookPreview = useRouteMatch('/book-preview');
  const isBook = AppTester.isBooks() || isDesignBooks;
  const isSuperPuper = AppTester.isSuperPuper();
  const isCompetitions = location.pathname.startsWith(LinkTo.awards);
  const isDvaDesign = AppTester.isDvaDesign();
  const isCGrave = AppTester.isCGRAVE();
  const [{ mainBookId }] = useQueryState();
  const isKiiidsArt = AppTester.isKiiidsArt();

  const { 
      channels, 
      loading
  } = useChannelsContext();

  const hasFeedInfo = useGetFeedInfo();

  const shouldVisibleFeedButton = useMemo(() => {
    if(isGreenAward) return false
    return !!hasFeedInfo
  } , [hasFeedInfo, isGreenAward])

  const shouldVisibleChannelButton = useMemo(() => {
    if (loading || !profile || channels?.length === 0) return false
    return channels?.some((channel) => {
      return hasPersonalChannel(channel, profile) || hasDefaultChannel(channel,profile)
    })
  } , [channels, profile, loading])

  const MainLogo = useGetLogo({});

  const isChapterPreview = useMemo(() => (mainBookId && isMainBookPreview), [mainBookId, isMainBookPreview])

  const flexBoxRef = useRef(null);
  const [isFlexBoxEmpty, setIsFlexBoxEmpty] = useState(true);
  
  const kiiidsCollections = useGetCatalogs('kids', profile?.accountId || '')

  const kiiidsPersonalCollection = useMemo(() => {
    return kiiidsCollections?.catalogs?.[0]
  }, [kiiidsCollections])


  const createKidsCard = useCallback(async () => {
    if (!profile) {
      emit('login')
      return
    }
    const collectionId = kiiidsPersonalCollection?.cardCollectionId


    const cardData : any = {
      "museumId": collectionId || null,
      "countryId": null,
      "artistId": profile?.accountId,
      "name": null,
      "images": null,
      "dateString": null,
      "isSelfPortrait": false,
      "isFragment": false,
      "isGameArt": false,
      "isLongreadGenerator": false,
      "isLongreadGeneratorTitle": false,
      "cardPersons": null,
      "creationCountry": null,
      "styleTime": null,
      "realMuseum": null,
      "styleLocation": null,
      "style": null,
      "objects": null,
      "userCollectionId": null,
      "mythologicalStories": null,
      "stories": null,
      "tagIds": null,
      "statusCard": 0,
      "mediaLink": "",
      "typeCard": "t_kids"
  }

    const createdCard: any = await API.Json(CardAPI.AddCard(cardData))
                          
    // console.log('catalogs',catalogs, createdCard)
    
    if (createdCard) window.open(`${process.env.REACT_APP_URL_KIIIDS_ART}/card/${createdCard}`, '_self')
    // const catalogs = API.fetch(`${cardUrl}/api/Collection/GetCatalogs${query}`, {}).then((r) => r.json())
  }, [emit, kiiidsPersonalCollection, profile])

  const [proTypeOptions, setProTypeOptions] = useState<{ label: string; value: string }[]>([]);
useEffect(() => {
    urlApi()
      .getLendPresTagsTree(i18n.language)
      .then((tree: any[]) => {
        const root = tree?.[0] || { additionalTags: [] };
  
        const options = (root.additionalTags || []).map((tag: any) => {
          const nameObj = tag.name?.find((n: any) => n.lang.toLowerCase() === i18n.language);
          return {
            label: nameObj?.name || tag.title,
            value: tag.tagId,
          };
        });
  
        setProTypeOptions(options);
  
        setNavProTypeValue(prev => {
          if (!prev) return null;
          return options.find((opt: any) => opt.value === prev.value) || null;
        });
      })
      .catch(err => {
        console.error('Не удалось загрузить типы проектов', err);
      });
  }, [i18n.language]);

  const checkIfEmpty = () => {
      if (flexBoxRef.current) {
        //@ts-ignore
        setIsFlexBoxEmpty(flexBoxRef.current.children.length === 0);
      }
    };

  useEffect(() => {
  const observer = new MutationObserver(() => {
    checkIfEmpty();
  });

  if (flexBoxRef.current) {
    observer.observe(flexBoxRef.current, { childList: true });
  }
  checkIfEmpty();

  return () => {
    if (observer) observer.disconnect();
  };
}, [flexBoxRef]);


  const isModer = useMemo(
    () => profile && bProfile.isModer(profile),
    [profile]
  );
  const isJuniorModer = useMemo(
    () => profile && profile?.rolesList?.includes("juniormoder"),
    [profile]
  );
  const canViewSuperGames = useMemo(
    () => (profile && profile.rolesList && Array.isArray(profile.rolesList) && (new ProfileRole(HsePolicies.can_view_games)).containsIn(profile.rolesList)
  ), [profile]);

  const isBriefModer = profile && profile.rolesList && Array.isArray(profile.rolesList)
    && (new ProfileRole(HsePolicies.access_brief_competitions)).containsIn(profile.rolesList);

  const isCompetitionModer = profile && profile.rolesList && Array.isArray(profile.rolesList)
    && (new ProfileRole(HsePolicies.access_competitions)).containsIn(profile.rolesList);

  const context = getContextFromAppName(ApplicationShared.application);

  const shouldDisplayLangSwitcher = useMemo(() => {
    //todo странная логика, разобраться
    return ((isGeo && !is834bp) || (!isMobile && !isGeo)) &&
    (!isLPU && !isGreenAward);
  } , [isGeo, isLPU, isGreenAward])

  const shouldDisplayNotifications = useMemo(() => {
    return profile && connection && !isDvaDesign && !isAgeytomesh && !isHseAnimation && !isMonaLisaTravels
  } , [profile, connection, isDvaDesign, isAgeytomesh, isHseAnimation])

  const shouldHideTeamInfo = useMemo(() => {
    return !(isAgeytomesh || isDvaDesign || isHseAnimation || isMonaLisaTravels) || !isMainOrTeam
  } , [isAgeytomesh, isDvaDesign, isHseAnimation, isMainOrTeam])

  const shouldDisplayGameButton = useMemo(() => {
    return (isModer || canViewSuperGames) && isMedia && !isLectureMediiia
  } , [profile, connection, isDvaDesign, isAgeytomesh, isHseAnimation])
  
  const shouldDisplayCreateButton =
    ((isTeam && (isModer || isTeamOwner)) || !isLMS) && !isTeamAdmin &&
    ![
      "places",
      "ageytomesh",
      "education",
      'dafes',
      "dvadesign",
      // "brnd",
      "superpuper",
      "monalisatravels",
      // "galllleryart",
    ].includes(context) &&
    !(isSuperPuper && !(isModer || isJuniorModer));

  const shouldDisplaySearch = getShouldDisplaySearch()

  const isTagsModalActive =
    useSelector(modalControllerSelector).name === "tags";
  const isCompetitionSendProjectActive =
    useSelector(modalControllerSelector).name === "send-project";
  //@ts-ignore
  const isModulesLMSHSE = team?.moderationType == ModerationType.LMS

  const createButtonTitle = useMemo(
    () =>
      isCompetitions && (isModer || isBriefModer || isCompetitionModer)? t("nav.create_button.create_competition") :
      isKiiidsArt? t('nav.create_button.add_work_kiiids') :
      isModulesLMSHSE ? t("nav.create_button.create_modul") : isBook
        ? t("nav.create_button.create_book") : isBrnd 
        ? t("nav.create_button.add_work") : isProDeziiign || isProHSE
        ? t("nav.create_button.create_presentation")
        : t("nav.create_button.create_project"),
    [isCompetitions, isModer, isBriefModer, isCompetitionModer, t, isKiiidsArt, isModulesLMSHSE, isBook, isBrnd]
  );

  const [setUserParam] = useOnlinesParam();
  const userParam = sessionStorage.getItem("userParam");

  const onLangSwitch = useCallback(
    (lang?: string) => {
      if (!lang) {
        lang = i18n.language === "ru" ? "en" : "ru";
      }

      SaveUserLang(lang);
      setAppLang(lang);
      i18n.changeLanguage(lang);
    },
    [i18n]
  );

  const onOnlinesLangSwitch = useCallback(
    (lang: string) => {
      SaveUserLang(lang);
      dispatch(setAppLang(lang));
      setQueryParams({ lang });
      i18n.changeLanguage(lang, () => window.location.reload());
    },
    [dispatch, setQueryParams, i18n]
  );


  useEffect(() => {
    if (isBrnd && lang?.length) {
      const {origin : base, pathname: route} = window.location
      history.push(`${route}${queryTab? `?tab=${queryTab}` : ''}`)
    }
  }, [])

  useEffect(() => {
    if (isOnlines) {
      setUserParam();
    }
  }, [location.pathname, setUserParam, isOnlines]);
  
  const items = useGetFilteredTabs()

  const SectionGeo = () => {

    return (
      <NavbarWidget.Links
        key={"links-widget"}
        theming={theme.navigationBar.links}
        items={items}
      />
    );
  };

  if (
    location.pathname.startsWith(CreateLinkTo.projectCreate()) ||
    location.pathname.startsWith("/competition-edit") ||
    location.pathname.startsWith(CreateLinkTo.bookCreate())
  ) {
    return null;
  }

  if (isTablet) {
    return <DeziignNavBarMobile onLangSwitch={onLangSwitch}  proTypeOptions={proTypeOptions} navProTypeValue={navProTypeValue} onProTypeChange={(opt) => {setNavProTypeValue(opt); if (opt) navigateWithType(opt.value); }}/>
  }

  if (isDODOnlines) {
    const SectionDeziign = () => {

      return (
        <NavbarWidget.Links
          key={"links-widget"}
          theming={{
            color: Colors.galBlack100,
            hoverColor: Colors.galBlack100,
            activeColor: Colors.galBlack100,
          }}
          items={items}
        />
      );
    };

    if (isMobile) {
      return (
        <NavBar
          theming={{
            zIndex: 99999,
            backgroundColor: theme.navigationBar.backgroundColor,
            borderBottomColor: theme.navigationBar.borderBottomColor,
            backgroundScrolling: theme.navigationBar.backgroundScrollingColor,
            boxShadow: theme.navigationBar.boxShadow,
            mobile: true,
          }}
          logo={
            <NeutralLink to={LinkTo.explore}>
              <LogoName>ONLINES</LogoName>
            </NeutralLink>
          }
          onLogoClick={() =>
            (window.location.href = "https://onlinesdesign.com/")
          }
          sections={[
            [
              <NavbarWidget.Projects
                key="links-widget"
                links={{
                  "Students projects": "/projects",
                  "Communication design. Basic level":
                    "/dop/communication-design-basic-level",
                  "Profession: Design": "/dop/profession-design",
                  About: "/dop/about",
                  Join: "/dop/join",
                }}
                theme={true}
              />,
            ],
            // This empty section for justify flex
          ]}
        />
      );
    }
    return (
      <NavBar
        errorComponent={
          visibleError && (
            <BacklogModalView onExit={() => setVisibleError(false)}/>
          )
        }
        theming={{
          zIndex: 99999,
          backgroundColor: theme.navigationBar.backgroundColor,
          borderBottomColor: theme.navigationBar.borderBottomColor,
          backgroundScrolling: theme.navigationBar.backgroundScrollingColor,
          boxShadow: theme.navigationBar.boxShadow,
        }}
        logo={
          <LogoName>
            {" "}
            <OnlinesLogo onClick={() => history.push("/" + userParam)}/>{" "}
          </LogoName>
        }
        // Logo via SVG places here
        onLogoClick={() => history.push("/")}
        sections={[
          // Left section ------------------------------------------------------------------------>
          [
            isDeziiign ? (
              <SectionDeziign key={"section-d"}/>
            ) : (
              <SectionGeo key={"section-d"}/>
            ),
          ],
          [],
          [
            <BLanguageSelectionComponentOnlines
              onLangSelect={onOnlinesLangSwitch}
              key="lang"
            />,
            <NeutralLink to="/open-day">
              <OpenDayButton>{t("onlinesNav.btns.open_day")}</OpenDayButton>
            </NeutralLink>,
            <ApplyBtn
              lang={i18n.language}
              href="https://calendly.com/onlinesdesign/application-q-a?back=1"
              target="_blank"
              size={"big"}
            >
              {t("onlinesNav.btns.apply")}
            </ApplyBtn>,
          ],
        ]}
      />
    );
  }

  return (
    <NavBarWrapper className={'NavBarWrapper'} isKiiidsArt={isKiiidsArt}>
    <NavBar
      errorComponent={
        visibleError && (
          <BacklogModalView onExit={() => setVisibleError(false)}/>
        )
      }
      theming={{
        zIndex: 99999,
        backgroundColor: theme.navigationBar.backgroundColor,
        borderBottomColor: theme.navigationBar.borderBottomColor,
        backgroundScrolling: theme.navigationBar.backgroundScrollingColor,
        boxShadow: theme.navigationBar.boxShadow,
      }}
      logo={MainLogo}
      onLogoClick={() => {
        history.push(LinkTo.explore);
      }}
      sections={[
        [
          isCGrave ? (
            <SectionCGrave key={'section-d'}/>
          ) : isSuperPuper ? (
            <SectionSuperPuper key={"section-d"}/>
          ) : isDeziiign ? (
            <SectionDeziign isFlexBoxEmpty={isFlexBoxEmpty} key={"section-d"}/>
          ) : (
            <SectionGeo key={"section-d"}/>
          ),
        ],
        [
          <ChapterPager />,
          <ViewTypeControllerWide/>,
          ...(shouldDisplaySearch
            ? [
              <MainSearchButton/>,
            ]
            : []),
          ...(
            shouldDisplayGameButton ? [
              <GameButton/>,
            ]
            : []),
          // <TeamInfo />,
          ...(shouldHideTeamInfo
            ? []
            : [<TeamInfo/>]),
          ...(shouldDisplayNotifications ? [
              <NotificationsController/>, 
              ...((!isKiiidsArt && shouldVisibleChannelButton) ? [<ChannelButton />] : []),
              ...((!isKiiidsArt && shouldVisibleFeedButton) ? [<FeedButton/>] : [])]
            : []),
          ...(shouldDisplayLangSwitcher /*!searchWidgetOpen ? */
            ? [
              <LangSwitcherWrapper isKiiidsArt={isKiiidsArt}>
                <BLangSwitcher
                  currentLanguage={i18n.language}
                  onLangSelect={onLangSwitch}
                  key="lang"
                  activeBg={isKiiidsArt ? '#94209E' : ''}
                  itemStyle={'border-radius: 8px;'}
                />
              </LangSwitcherWrapper>,
            ]
            : []),
          ...((isPreview || isTeamLgPreview) && id
            ? [
              <FlexBox key="button-widget" align="center">
                <RectangularButtonHollow
                  onClick={() =>
                    isChapterPreview ? history.push(
                      CreateLinkTo.bookEdit(mainBookId ?? 'undefined')
                    ) : isMainBookPreview ? history.push(
                      CreateLinkTo.bookEdit(
                        isPreview?.params?.id ?? "undefined"
                      )
                    ) : isTeamLgPreview?.params?.id ?
                        history.push(CreateLinkTo.teamEdit(isTeamLgPreview?.params?.id ?? 'undefined') + '?tab=lg')
                      : history.push(
                      CreateLinkTo.projectEdit(
                        isPreview?.params?.id ?? "undefined"
                      )
                    )
                  }
                >
                  {t("nav.exit_preview") ?? "Exit"}
                </RectangularButtonHollow>
              </FlexBox>,
            ]
            : []),
          ...((
            isCompetitions
              ? !isAgeytomesh && !isHseAnimation && 
              !isPreview && !isTeamLgPreview && 
              shouldDisplayCreateButton
              : !isAgeytomesh && !isHseAnimation && !isPreview && !isTeamLgPreview && !isGreenAward && shouldDisplayCreateButton
          )
            ? [
              <NavbarButtonWrapper key="button-widget" align="center" isKiiidsArt={isKiiidsArt}>
                {isDropdownEnabled ? (
                <>
                <DropdowCreateProjectnWrapper directionMobile="column" offsetBottom={0} widthMobile={'100%'}>
                  <ProjectEditPageGridInput isColumns>
                    <CustomDropdown
                      lang={i18n.language}
                      value={navProTypeValue}
                      onChange={(option: any) => {
                        setNavProTypeValue(option);
                        history.push(CreateLinkTo.projectCreate(), { selectedType: option.value });
                      }}
                      onMenuOpen={() => {
                        dispatch(NavbarSearchActions.setNavbarSearchToggle({ data: false }));
                        document.body.click();
                      }}
                      options={proTypeOptions}
                      placeholder={createButtonTitle ?? "Выбрать тип"}
                    />
                  </ProjectEditPageGridInput>
                </DropdowCreateProjectnWrapper>
                        </>
                      ) : (
                <NavbarButtonFilled
                  fixedSize
                  style={{
                    backgroundColor: isKiiidsArt? '#94209E' : theme.navigationBar.btns.create.bg,
                    color: theme.navigationBar.btns.create.color,
                    border: theme.navigationBar.btns.create.border,
                    padding: isKiiidsArt? "10px 24px" : "6px 24px",
                    minWidth: isKiiidsArt? "173px" : "auto",
                    whiteSpace: "nowrap",
                    fontWeight: 700,
                    ...(isKiiidsArt? {fontSize: '15px'} : {}),
                    borderRadius: isMedia || isKiiidsArt ? '8px' : ''
                  }}
                  onClick={() =>
                    isKiiidsArt
                      ? createKidsCard()
                      : isCompetitions && (isModer || isBriefModer || isCompetitionModer)
                        ? history.push(CreateLinkTo.competitionCreate())
                        : isDesignBooks || isGalllleryBooks
                          ? history.push(CreateLinkTo.bookCreate())
                          : history.push(CreateLinkTo.projectCreate())
                  }
                >
                  {createButtonTitle ?? "create"}
                </NavbarButtonFilled>
              )}
              </NavbarButtonWrapper>,
            ]
            : []),
          <WidgetLogin personalCollection={isKiiidsArt? kiiidsPersonalCollection : undefined} />,
        ],
      ]}
    >
      {(isGeo || isMedia || isHseSpace) && isTablet && (
        <ModalMenuContextMobileNew visible={visibleChoosePopUp}/>
      )}
    </NavBar>
    </NavBarWrapper>
  );
};
import { useHistory, useLocation, useParams } from "react-router-dom";
import { FC, useState, useCallback, useEffect, useMemo, useRef } from "react";
import { useTranslation } from "react-i18next";
import { NavBar, NavbarWidget } from "shared/components/__FOX__/NAV/src";
import {
  BLangSwitcher,
  Colors,
  FlexBox,
  NavbarButtonFilled,
  NavbarLogoName,
  useBreakpoint,
  useIsMobile,
} from "@brg/ui";
import { CreateLinkTo, LinkTo } from "shared/constants/linkTo";
import styled, { css, useTheme } from "styled-components";
import { BacklogModalView } from "shared/components/backlog";
import { setAppLang } from "../components/__ADDONS__/__LANG__/Slice";
import { SaveUserLang } from "../components/__ADDONS__/__LANG__/Utils/GetUserLang";
import { AppTester, getContextFromAppName } from "supporting";
import {
  LayoutConst,
  modalControllerSelector,
} from "core/modules";
import useSingleTagModal from "../hooks/useSingleTagModal";
import DeziignNavBarMobile from "./DeziignNavBarMobile";
import WidgetLogin from "./WidgetLogin";
import SectionDeziign from "./SectionDeziign";
import { RectangularButtonHollow } from "shared/components/buttons";
import { ApplicationShared, bURL } from "core";
import { useAuth } from "../../core/hooks/auth/useAuth";
import { useRouteMatch } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import OnlinesLogo from "shared/assets/logos/OnlinesLogo";
import { ApplyBtn } from "shared/components/Footer/OnlinesFooter";
import { useOnlinesParam } from "shared/hooks/OnlinesParamFilter";
import { BLanguageSelectionComponentOnlines } from "core/components/BLanguageSelectionComponentOnlines";
import useQueryState from "shared/hooks/useQueryState";
import { ModalMenuContextMobileNew } from "./ModalMenuContextMobileNew";
import { NeutralLink } from "../components/link/styles";
import { ProfileRole, bProfile, useProfile } from "@brg/auth";
import ViewTypeControllerWide from "../components/ViewTypeControllerWide/ViewTypeControllerWide";
import NotificationsController from "../components/NotificationsController/NotificationsController";
import { useNotificationContext } from "../contexts/NotificationContext";
import { MainSearchButton } from "shared/components/MainSearchController/MainSearchButton";
import TeamInfo from "../components/TeamInfo/TeamInfo";
import useExternalOrganization from "../pages/exploreHseContextsNew/useExternalOrganization";
import { ModerationType } from "../pages/teams/const/ModerationTypes";
import SectionSuperPuper from "./SectionSuperPuper";
import { HsePolicies } from "shared/constants/HsePolicies";
import FeedButton from "../components/NotificationsController/FeedButton";
import SectionCGrave from "./SectionCGrave";
import {useGetFilteredTabs} from "../components/navigationSystem/useGetFilteredTabs";
import { useGetLogo } from "shared/components/navigationSystem/useGetLogo";
import {getShouldDisplaySearch} from "../helpers/getShouldDisplaySearch";
import { API, CardAPI, Endpoints, Team } from "@brg/api";
import { useGetCatalogs } from "shared/hooks/api/useGetCatalogs";
import { ProjectEditPageGridInput } from "_deziiign/books/pages/BookEdit/styles";
import { Input } from "@brg/input";
import urlApi from "shared/actions/urlApi";
import ChannelButton from "shared/components/NotificationsController/ChannelButton";
import { NavbarSearchActions } from "shared/reducers/NavbarSearch";
import GameButton from "shared/components/NotificationsController/GameButton";
import { useChannelsContext } from "shared/contexts/ChannelsContext";
import { hasDefaultChannel, hasPersonalChannel } from "shared/helpers/teamsStatus";
import { useGetFeedInfo } from "shared/hooks/api/useGetFeedInfo";
import { ChapterPager } from "./components/ChapterPager";

interface CustomDropdownProps {
  lang: string;
}

export const LogoName = styled(NavbarLogoName)`
  top: -1px;
`;

export const DropdowCreateProjectnWrapper = styled(FlexBox)`
  white-space: nowrap;
`;

const CustomDropdown = styled(Input.Dropdown)`
  .brg-input__control {
    height: 20px !important;
    width: ${p => p.lang === 'en' ? '219px' : '250px'} !important;
    color: #FEFEFE !important;
    background-color: #151514 !important;
    border: 1px solid #444 !important;
    box-shadow: none !important;
    padding-left: 8px;
    cursor: pointer;
  }

  .brg-input__value-container{
    height: 100% !important;
    margin-top: -3px;
  }

  .brg-input__control:hover svg {
    fill:  #FEFEFE !important;
    color: #FEFEFE !important;
  }

  .brg-input__placeholder{
    color: #FEFEFE !important;
    font-weight: 600;
  },

  .brg-input__placeholder:hover{
    color: #FEFEFE !important;
  }
  .brg-input__control:hover .brg-input__placeholder {
    color: #FEFEFE !important;
  }

  .brg-input__menu {
    border-radius: 3px;
    margin-top: 8px;
  }

  .brg-input__menu-list {
    padding: 0;
  }

  .brg-input__option {
    color: #ddd !important;
    padding: 8px 12px;
    display: flex;
    word-wrap: break-word;
    overflow-wrap: break-word;
    white-space: normal;
  }

  .brg-input__indicator {
    width: auto;
    
  }

  .brg-input__dropdown-indicator svg path{
    fill: #fefefe !important;
  }

  .brg-input__dropdown-indicator{
    opacity: 1;
    margin-right: 14px;
    padding: 8px 8px 8px 10px;
  }

  .brg-input__control:hover svg { fill: #FEFEFE !important; }

`;

export const OpenDayButton = styled(FlexBox)`
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  /* margin-right: 48px; */
  background: #fa4800;
  border-radius: 16px;
  padding: 12px 32px;
  color: #fff;
  align-items: center;
  gap: 10px;

  white-space: nowrap;

  @media (max-width: ${LayoutConst.screen.m}px) {
    font-size: 12px;
    line-height: 16px;
    gap: 3px;
    padding: 6px 12px;
    margin-right: 12px;
    margin-left: -12px;
    border-radius: 12px;
  }
`;

const NavBarWrapper = styled.div<any>`
  ${p => p.isKiiidsArt && 
    css`
    & > div > div > div {
      @media (max-height: ${LayoutConst.screen.height.projectCover}px) {
          height: 52px;
          min-height: 52px;       
        }
    }       
      div#navbar {
        #navbar-sections {
          margin-left: 24px;
        }
        .links-widget-item {
          font-size: 15px;
        }
        margin: 0 40px;
        @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
          margin: 0 22px 0 32px;
        }
        @media (max-width: ${LayoutConst.screen.l}px) {
          margin: 0 16px;
        }
      }
    `
  }
`

const NavbarButtonWrapper = styled<any>(FlexBox)`
  button {
    ${p => !p.isKiiidsArt && 'max-width: max-content;'}
    ${p => p.isKiiidsArt && css`
        height: 40px !important;
      `}
  }
`

const LangSwitcherWrapper = styled.div<any>`
  div.langitem-active {
    ${p => p.isKiiidsArt && 'color: #FEFEFE;'}
  }
`
const cardUrl = Endpoints.cardsMnePw;

export const DeziignNavBar: FC = () => {
  const location = useLocation();
  const history = useHistory();
  const { emit } = useAuth();
  const {
    t,
    i18n,
    i18n: { language },
  } = useTranslation();
  const dispatch = useDispatch();
  const [showTagModal] = useSingleTagModal();
  const profile = useProfile();
  const { connection } = useNotificationContext();

  const theme = useTheme();
  const [visibleError, setVisibleError] = useState(false);
  const [visibleChoosePopUp, setVisibleChoosePopUp] = useState<boolean>(false);
  const [{ lang, tab: queryTab }, setQueryParams] = useQueryState();

  const isBrnd = AppTester.isBrnd();
  const isAgeytomesh = AppTester.isAgeytomesh();
  const isHseAnimation = AppTester.isHseAnimation();
  const isDeziiign = AppTester.isDeziiign();
  const isGeo = AppTester.isGeograffee();
  const isOnlines = AppTester.isOnlines();
  const isMedia = AppTester.isMediiia();
  const isLectureMediiia = AppTester.isLectureMediiia();
  const isHseSpace = AppTester.isHseSpace();
  const isLPU = AppTester.isLPUDesign();
  const isGreenAward = AppTester.isGreenAward();
  const isProDeziiign = AppTester.isProDeziiign();
  const isProHSE = AppTester.isProHSE();
  const isMonaLisaTravels = AppTester.isMonaLisaTravels();
  const isDODOnlines =
    location.pathname.startsWith("/dop") || AppTester.isOnlines();
  const isPreview = useRouteMatch<{ id: string }>([
    "/preview/:id",
    "/books/book-preview/:id",
    "/book-preview/:id",
  ]);
  const isTeamLgPreview = useRouteMatch<{ id: string }>('/team-longread-preview/:id');
  const isTeamAdmin = useRouteMatch('/teamAdmin')
  const isMain = !!useRouteMatch("/")?.isExact;
  const isForcedLanding = !!useRouteMatch('/brnd')
  const isTeam = !!useRouteMatch("/teams/:id");
  const isMainOrTeam = isMain || isTeam || isForcedLanding;
  const id = isPreview && isPreview?.params?.id || isTeamLgPreview && isTeamLgPreview?.params?.id;

  const teamId = useRouteMatch('/teams/:id');

  const { teamName } = useParams<{ teamName: string }>();
  const team = useExternalOrganization(teamName);

  // console.log('profile', profile)


  const isDropdownEnabled = isProDeziiign || isProHSE;

  const [navProTypeValue, setNavProTypeValue] = useState<{ label: string; value: string } | null>(null);

  useEffect(() => {
    const createPath = CreateLinkTo.projectCreate();
    if (!location.pathname.startsWith(createPath)) {
      setNavProTypeValue(null);
    }
  }, [location.pathname]);
  
  const navigateWithType = (typeValue: string) => {
    history.push(CreateLinkTo.projectCreate(), { selectedType: typeValue })
  };

  // @ts-ignore
  // const [isTeamOwner] = useGetIsOwner(team?.teamId ?? "");

  const isTeamOwner = useMemo(
    () => {
      const tTeam = team as Team;

      if (!profile || !team) return undefined;

      return tTeam?.ownersIDs?.includes(profile?.accountId)
    } 
  , [team, profile])
    

  // @ts-ignore
  const isLMS =
    AppTester.isLMSHSE() ||
    //@ts-ignore
    team?.moderationType == ModerationType.LMS;

  const isMobile = useIsMobile();
  const isTablet = useBreakpoint(1200);
  const is834bp = useBreakpoint(834);
  const isDesignBooks = AppTester.isBooksMain();
  const isGalllleryBooks = AppTester.isBooksGallllery();
  const isMainBookPreview = useRouteMatch('/book-preview');
  const isBook = AppTester.isBooks() || isDesignBooks;
  const isSuperPuper = AppTester.isSuperPuper();
  const isCompetitions = location.pathname.startsWith(LinkTo.awards);
  const isDvaDesign = AppTester.isDvaDesign();
  const isCGrave = AppTester.isCGRAVE();
  const [{ mainBookId }] = useQueryState();
  const isKiiidsArt = AppTester.isKiiidsArt();

  const { 
      channels, 
      loading
  } = useChannelsContext();

  const hasFeedInfo = useGetFeedInfo();

  const shouldVisibleFeedButton = useMemo(() => {
    if(isGreenAward) return false
    return !!hasFeedInfo
  } , [hasFeedInfo, isGreenAward])

  const shouldVisibleChannelButton = useMemo(() => {
    if (loading || !profile || channels?.length === 0) return false
    return channels?.some((channel) => {
      return hasPersonalChannel(channel, profile) || hasDefaultChannel(channel,profile)
    })
  } , [channels, profile, loading])

  const MainLogo = useGetLogo({});

  const isChapterPreview = useMemo(() => (mainBookId && isMainBookPreview), [mainBookId, isMainBookPreview])

  const flexBoxRef = useRef(null);
  const [isFlexBoxEmpty, setIsFlexBoxEmpty] = useState(true);
  
  const kiiidsCollections = useGetCatalogs('kids', profile?.accountId || '')

  const kiiidsPersonalCollection = useMemo(() => {
    return kiiidsCollections?.catalogs?.[0]
  }, [kiiidsCollections])


  const createKidsCard = useCallback(async () => {
    if (!profile) {
      emit('login')
      return
    }
    const collectionId = kiiidsPersonalCollection?.cardCollectionId


    const cardData : any = {
      "museumId": collectionId || null,
      "countryId": null,
      "artistId": profile?.accountId,
      "name": null,
      "images": null,
      "dateString": null,
      "isSelfPortrait": false,
      "isFragment": false,
      "isGameArt": false,
      "isLongreadGenerator": false,
      "isLongreadGeneratorTitle": false,
      "cardPersons": null,
      "creationCountry": null,
      "styleTime": null,
      "realMuseum": null,
      "styleLocation": null,
      "style": null,
      "objects": null,
      "userCollectionId": null,
      "mythologicalStories": null,
      "stories": null,
      "tagIds": null,
      "statusCard": 0,
      "mediaLink": "",
      "typeCard": "t_kids"
  }

    const createdCard: any = await API.Json(CardAPI.AddCard(cardData))
                          
    // console.log('catalogs',catalogs, createdCard)
    
    if (createdCard) window.open(`${process.env.REACT_APP_URL_KIIIDS_ART}/card/${createdCard}`, '_self')
    // const catalogs = API.fetch(`${cardUrl}/api/Collection/GetCatalogs${query}`, {}).then((r) => r.json())
  }, [emit, kiiidsPersonalCollection, profile])

  const [proTypeOptions, setProTypeOptions] = useState<{ label: string; value: string }[]>([]);
useEffect(() => {
    urlApi()
      .getLendPresTagsTree(i18n.language)
      .then((tree: any[]) => {
        const root = tree?.[0] || { additionalTags: [] };
  
        const options = (root.additionalTags || []).map((tag: any) => {
          const nameObj = tag.name?.find((n: any) => n.lang.toLowerCase() === i18n.language);
          return {
            label: nameObj?.name || tag.title,
            value: tag.tagId,
          };
        });
  
        setProTypeOptions(options);
  
        setNavProTypeValue(prev => {
          if (!prev) return null;
          return options.find((opt: any) => opt.value === prev.value) || null;
        });
      })
      .catch(err => {
        console.error('Не удалось загрузить типы проектов', err);
      });
  }, [i18n.language]);

  const checkIfEmpty = () => {
      if (flexBoxRef.current) {
        //@ts-ignore
        setIsFlexBoxEmpty(flexBoxRef.current.children.length === 0);
      }
    };

  useEffect(() => {
  const observer = new MutationObserver(() => {
    checkIfEmpty();
  });

  if (flexBoxRef.current) {
    observer.observe(flexBoxRef.current, { childList: true });
  }
  checkIfEmpty();

  return () => {
    if (observer) observer.disconnect();
  };
}, [flexBoxRef]);


  const isModer = useMemo(
    () => profile && bProfile.isModer(profile),
    [profile]
  );
  const isJuniorModer = useMemo(
    () => profile && profile?.rolesList?.includes("juniormoder"),
    [profile]
  );
  const canViewSuperGames = useMemo(
    () => (profile && profile.rolesList && Array.isArray(profile.rolesList) && (new ProfileRole(HsePolicies.can_view_games)).containsIn(profile.rolesList)
  ), [profile]);

  const isBriefModer = profile && profile.rolesList && Array.isArray(profile.rolesList)
    && (new ProfileRole(HsePolicies.access_brief_competitions)).containsIn(profile.rolesList);

  const isCompetitionModer = profile && profile.rolesList && Array.isArray(profile.rolesList)
    && (new ProfileRole(HsePolicies.access_competitions)).containsIn(profile.rolesList);

  const context = getContextFromAppName(ApplicationShared.application);

  const shouldDisplayLangSwitcher = useMemo(() => {
    //todo странная логика, разобраться
    return ((isGeo && !is834bp) || (!isMobile && !isGeo)) &&
    (!isLPU && !isGreenAward);
  } , [isGeo, isLPU, isGreenAward])

  const shouldDisplayNotifications = useMemo(() => {
    return profile && connection && !isDvaDesign && !isAgeytomesh && !isHseAnimation && !isMonaLisaTravels
  } , [profile, connection, isDvaDesign, isAgeytomesh, isHseAnimation])

  const shouldHideTeamInfo = useMemo(() => {
    return !(isAgeytomesh || isDvaDesign || isHseAnimation || isMonaLisaTravels) || !isMainOrTeam
  } , [isAgeytomesh, isDvaDesign, isHseAnimation, isMainOrTeam])

  const shouldDisplayGameButton = useMemo(() => {
    return (isModer || canViewSuperGames) && isMedia && !isLectureMediiia
  } , [profile, connection, isDvaDesign, isAgeytomesh, isHseAnimation])
  
  const shouldDisplayCreateButton =
    ((isTeam && (isModer || isTeamOwner)) || !isLMS) && !isTeamAdmin &&
    ![
      "places",
      "ageytomesh",
      "education",
      'dafes',
      "dvadesign",
      // "brnd",
      "superpuper",
      "monalisatravels",
      // "galllleryart",
    ].includes(context) &&
    !(isSuperPuper && !(isModer || isJuniorModer));

  const shouldDisplaySearch = getShouldDisplaySearch()

  const isTagsModalActive =
    useSelector(modalControllerSelector).name === "tags";
  const isCompetitionSendProjectActive =
    useSelector(modalControllerSelector).name === "send-project";
  //@ts-ignore
  const isModulesLMSHSE = team?.moderationType == ModerationType.LMS

  const createButtonTitle = useMemo(
    () =>
      isCompetitions && (isModer || isBriefModer || isCompetitionModer)? t("nav.create_button.create_competition") :
      isKiiidsArt? t('nav.create_button.add_work_kiiids') :
      isModulesLMSHSE ? t("nav.create_button.create_modul") : isBook
        ? t("nav.create_button.create_book") : isBrnd 
        ? t("nav.create_button.add_work") : isProDeziiign || isProHSE
        ? t("nav.create_button.create_presentation")
        : t("nav.create_button.create_project"),
    [isCompetitions, isModer, isBriefModer, isCompetitionModer, t, isKiiidsArt, isModulesLMSHSE, isBook, isBrnd]
  );

  const [setUserParam] = useOnlinesParam();
  const userParam = sessionStorage.getItem("userParam");

  const onLangSwitch = useCallback(
    (lang?: string) => {
      if (!lang) {
        lang = i18n.language === "ru" ? "en" : "ru";
      }

      SaveUserLang(lang);
      setAppLang(lang);
      i18n.changeLanguage(lang);
    },
    [i18n]
  );

  const onOnlinesLangSwitch = useCallback(
    (lang: string) => {
      SaveUserLang(lang);
      dispatch(setAppLang(lang));
      setQueryParams({ lang });
      i18n.changeLanguage(lang, () => window.location.reload());
    },
    [dispatch, setQueryParams, i18n]
  );


  useEffect(() => {
    if (isBrnd && lang?.length) {
      const {origin : base, pathname: route} = window.location
      history.push(`${route}${queryTab? `?tab=${queryTab}` : ''}`)
    }
  }, [])

  useEffect(() => {
    if (isOnlines) {
      setUserParam();
    }
  }, [location.pathname, setUserParam, isOnlines]);
  
  const items = useGetFilteredTabs()

  const SectionGeo = () => {

    return (
      <NavbarWidget.Links
        key={"links-widget"}
        theming={theme.navigationBar.links}
        items={items}
      />
    );
  };

  if (
    location.pathname.startsWith(CreateLinkTo.projectCreate()) ||
    location.pathname.startsWith("/competition-edit") ||
    location.pathname.startsWith(CreateLinkTo.bookCreate())
  ) {
    return null;
  }

  if (isTablet) {
    return <DeziignNavBarMobile onLangSwitch={onLangSwitch}  proTypeOptions={proTypeOptions} navProTypeValue={navProTypeValue} onProTypeChange={(opt) => {setNavProTypeValue(opt); if (opt) navigateWithType(opt.value); }}/>
  }

  if (isDODOnlines) {
    const SectionDeziign = () => {

      return (
        <NavbarWidget.Links
          key={"links-widget"}
          theming={{
            color: Colors.galBlack100,
            hoverColor: Colors.galBlack100,
            activeColor: Colors.galBlack100,
          }}
          items={items}
        />
      );
    };

    if (isMobile) {
      return (
        <NavBar
          theming={{
            zIndex: 99999,
            backgroundColor: theme.navigationBar.backgroundColor,
            borderBottomColor: theme.navigationBar.borderBottomColor,
            backgroundScrolling: theme.navigationBar.backgroundScrollingColor,
            boxShadow: theme.navigationBar.boxShadow,
            mobile: true,
          }}
          logo={
            <NeutralLink to={LinkTo.explore}>
              <LogoName>ONLINES</LogoName>
            </NeutralLink>
          }
          onLogoClick={() =>
            (window.location.href = "https://onlinesdesign.com/")
          }
          sections={[
            [
              <NavbarWidget.Projects
                key="links-widget"
                links={{
                  "Students projects": "/projects",
                  "Communication design. Basic level":
                    "/dop/communication-design-basic-level",
                  "Profession: Design": "/dop/profession-design",
                  About: "/dop/about",
                  Join: "/dop/join",
                }}
                theme={true}
              />,
            ],
            // This empty section for justify flex
          ]}
        />
      );
    }
    return (
      <NavBar
        errorComponent={
          visibleError && (
            <BacklogModalView onExit={() => setVisibleError(false)}/>
          )
        }
        theming={{
          zIndex: 99999,
          backgroundColor: theme.navigationBar.backgroundColor,
          borderBottomColor: theme.navigationBar.borderBottomColor,
          backgroundScrolling: theme.navigationBar.backgroundScrollingColor,
          boxShadow: theme.navigationBar.boxShadow,
        }}
        logo={
          <LogoName>
            {" "}
            <OnlinesLogo onClick={() => history.push("/" + userParam)}/>{" "}
          </LogoName>
        }
        // Logo via SVG places here
        onLogoClick={() => history.push("/")}
        sections={[
          // Left section ------------------------------------------------------------------------>
          [
            isDeziiign ? (
              <SectionDeziign key={"section-d"}/>
            ) : (
              <SectionGeo key={"section-d"}/>
            ),
          ],
          [],
          [
            <BLanguageSelectionComponentOnlines
              onLangSelect={onOnlinesLangSwitch}
              key="lang"
            />,
            <NeutralLink to="/open-day">
              <OpenDayButton>{t("onlinesNav.btns.open_day")}</OpenDayButton>
            </NeutralLink>,
            <ApplyBtn
              lang={i18n.language}
              href="https://calendly.com/onlinesdesign/application-q-a?back=1"
              target="_blank"
              size={"big"}
            >
              {t("onlinesNav.btns.apply")}
            </ApplyBtn>,
          ],
        ]}
      />
    );
  }

  return (
    <NavBarWrapper className={'NavBarWrapper'} isKiiidsArt={isKiiidsArt}>
    <NavBar
      errorComponent={
        visibleError && (
          <BacklogModalView onExit={() => setVisibleError(false)}/>
        )
      }
      theming={{
        zIndex: 99999,
        backgroundColor: theme.navigationBar.backgroundColor,
        borderBottomColor: theme.navigationBar.borderBottomColor,
        backgroundScrolling: theme.navigationBar.backgroundScrollingColor,
        boxShadow: theme.navigationBar.boxShadow,
      }}
      logo={MainLogo}
      onLogoClick={() => {
        history.push(LinkTo.explore);
      }}
      sections={[
        [
          isCGrave ? (
            <SectionCGrave key={'section-d'}/>
          ) : isSuperPuper ? (
            <SectionSuperPuper key={"section-d"}/>
          ) : isDeziiign ? (
            <SectionDeziign isFlexBoxEmpty={isFlexBoxEmpty} key={"section-d"}/>
          ) : (
            <SectionGeo key={"section-d"}/>
          ),
        ],
        [
          <ChapterPager />,
          <ViewTypeControllerWide/>,
          ...(shouldDisplaySearch
            ? [
              <MainSearchButton/>,
            ]
            : []),
          ...(
            shouldDisplayGameButton ? [
              <GameButton/>,
            ]
            : []),
          // <TeamInfo />,
          ...(shouldHideTeamInfo
            ? []
            : [<TeamInfo/>]),
          ...(shouldDisplayNotifications ? [
              <NotificationsController/>, 
              ...((!isKiiidsArt && shouldVisibleChannelButton) ? [<ChannelButton />] : []),
              ...((!isKiiidsArt && shouldVisibleFeedButton) ? [<FeedButton/>] : [])]
            : []),
          ...(shouldDisplayLangSwitcher /*!searchWidgetOpen ? */
            ? [
              <LangSwitcherWrapper isKiiidsArt={isKiiidsArt}>
                <BLangSwitcher
                  currentLanguage={i18n.language}
                  onLangSelect={onLangSwitch}
                  key="lang"
                  activeBg={isKiiidsArt ? '#94209E' : ''}
                  itemStyle={'border-radius: 8px;'}
                />
              </LangSwitcherWrapper>,
            ]
            : []),
          ...((isPreview || isTeamLgPreview) && id
            ? [
              <FlexBox key="button-widget" align="center">
                <RectangularButtonHollow
                  onClick={() =>
                    isChapterPreview ? history.push(
                      CreateLinkTo.bookEdit(mainBookId ?? 'undefined')
                    ) : isMainBookPreview ? history.push(
                      CreateLinkTo.bookEdit(
                        isPreview?.params?.id ?? "undefined"
                      )
                    ) : isTeamLgPreview?.params?.id ?
                        history.push(CreateLinkTo.teamEdit(isTeamLgPreview?.params?.id ?? 'undefined') + '?tab=lg')
                      : history.push(
                      CreateLinkTo.projectEdit(
                        isPreview?.params?.id ?? "undefined"
                      )
                    )
                  }
                >
                  {t("nav.exit_preview") ?? "Exit"}
                </RectangularButtonHollow>
              </FlexBox>,
            ]
            : []),
          ...((
            isCompetitions
              ? !isAgeytomesh && !isHseAnimation && 
              !isPreview && !isTeamLgPreview && 
              shouldDisplayCreateButton
              : !isAgeytomesh && !isHseAnimation && !isPreview && !isTeamLgPreview && !isGreenAward && shouldDisplayCreateButton
          )
            ? [
              <NavbarButtonWrapper key="button-widget" align="center" isKiiidsArt={isKiiidsArt}>
                {isDropdownEnabled ? (
                <>
                <DropdowCreateProjectnWrapper directionMobile="column" offsetBottom={0} widthMobile={'100%'}>
                  <ProjectEditPageGridInput isColumns>
                    <CustomDropdown
                      lang={i18n.language}
                      value={navProTypeValue}
                      onChange={(option: any) => {
                        setNavProTypeValue(option);
                        history.push(CreateLinkTo.projectCreate(), { selectedType: option.value });
                      }}
                      onMenuOpen={() => {
                        dispatch(NavbarSearchActions.setNavbarSearchToggle({ data: false }));
                        document.body.click();
                      }}
                      options={proTypeOptions}
                      placeholder={createButtonTitle ?? "Выбрать тип"}
                    />
                  </ProjectEditPageGridInput>
                </DropdowCreateProjectnWrapper>
                        </>
                      ) : (
                <NavbarButtonFilled
                  fixedSize
                  style={{
                    backgroundColor: isKiiidsArt? '#94209E' : theme.navigationBar.btns.create.bg,
                    color: theme.navigationBar.btns.create.color,
                    border: theme.navigationBar.btns.create.border,
                    padding: isKiiidsArt? "10px 24px" : "6px 24px",
                    minWidth: isKiiidsArt? "173px" : "auto",
                    whiteSpace: "nowrap",
                    fontWeight: 700,
                    ...(isKiiidsArt? {fontSize: '15px'} : {}),
                    borderRadius: isMedia || isKiiidsArt ? '8px' : ''
                  }}
                  onClick={() =>
                    isKiiidsArt
                      ? createKidsCard()
                      : isCompetitions && (isModer || isBriefModer || isCompetitionModer)
                        ? history.push(CreateLinkTo.competitionCreate())
                        : isDesignBooks || isGalllleryBooks
                          ? history.push(CreateLinkTo.bookCreate())
                          : history.push(CreateLinkTo.projectCreate())
                  }
                >
                  {createButtonTitle ?? "create"}
                </NavbarButtonFilled>
              )}
              </NavbarButtonWrapper>,
            ]
            : []),
          <WidgetLogin personalCollection={isKiiidsArt? kiiidsPersonalCollection : undefined} />,
        ],
      ]}
    >
      {(isGeo || isMedia || isHseSpace) && isTablet && (
        <ModalMenuContextMobileNew visible={visibleChoosePopUp}/>
      )}
    </NavBar>
    </NavBarWrapper>
  );
};
